class ObserverManager {
    constructor() {
        this.entries = [];
    }
    add(el, callback) {
        this.entries.push({ el, callback });
        observer.observe(el);
    }
    remove(entry) {
        const index = this.entries.indexOf(entry);
        this.entries.splice(index, 1);
    }
    intersect(el) {
        const entry = this.entries.find(entry => entry.el === el);
        if (entry) {
            entry.callback();
            this.remove(entry);
        }
    }
    isSupported() {
        return !(!('IntersectionObserver' in window) ||
            !('IntersectionObserverEntry' in window) ||
            !('intersectionRatio' in window.IntersectionObserverEntry.prototype));
    }
}
const manager = new ObserverManager;
let observer = {
    observe(element) {
        manager.intersect(element);
    }
};
if (manager.isSupported()) {
    observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                manager.intersect(entry.target);
                observer.unobserve(entry.target);
            }
        });
    });
}
export default manager;
